export default "__VITE_ASSET__F$jPfd2C__"